'use client'

import { usePathname, useRouter } from 'next/navigation'

interface LanguageSwitcherProps {
  locale: string
}

/**
 * Language switcher component
 * Shows "English | Deutsch" with the current language highlighted
 * Sets NEXT_LOCALE cookie on language change
 */
export function LanguageSwitcher({ locale }: LanguageSwitcherProps) {
  const pathname = usePathname()
  const router = useRouter()

  const switchLocale = (newLocale: string) => {
    // Set the cookie for 1 year
    document.cookie = `NEXT_LOCALE=${newLocale}; path=/; max-age=31536000; SameSite=Lax`

    // Replace the locale in the current path
    const segments = pathname.split('/')
    // segments[0] is empty string (before first /), segments[1] is the locale
    if (segments[1] === 'en' || segments[1] === 'de') {
      segments[1] = newLocale
    } else {
      // If no locale in path, add it
      segments.splice(1, 0, newLocale)
    }
    const newPath = segments.join('/') || '/'
    router.push(newPath)
  }

  return (
    <div className="flex items-center gap-2 text-sm text-night/70">
      {locale === 'en' ? (
        <span className="text-night font-medium">English</span>
      ) : (
        <button
          onClick={() => switchLocale('en')}
          className="hover:text-night transition-colors"
        >
          English
        </button>
      )}
      <span className="text-night/30">|</span>
      {locale === 'de' ? (
        <span className="text-night font-medium">Deutsch</span>
      ) : (
        <button
          onClick={() => switchLocale('de')}
          className="hover:text-night transition-colors"
        >
          Deutsch
        </button>
      )}
    </div>
  )
}
